/* RC49: configurator extras + tax display; function-scoped loading for performance. */
(function(){
  'use strict';
  let queued=false;
  function clean(v){return String(v==null?'':v).replace(/[_-]+/g,' ').replace(/\s+/g,' ').trim();}
  function basis(v){const b=clean(v||'Stk').toLowerCase().replace('²','2').replace(/\s+/g,'');return (b==='m2'||b==='qm'||b==='m²')?'m2':'Stk';}
  function money(v){const n=Number(String(v||0).replace(',','.'))||0;return 'CHF '+n.toLocaleString('de-CH',{minimumFractionDigits:2,maximumFractionDigits:2});}
  function taxMode(){try{return localStorage.getItem('rk_tax_display')==='net'?'net':'gross';}catch(e){return 'gross';}}
  function priceWithTax(v,b){
    const n=Number(String(v||0).replace(',','.'))||0;
    if(window.RKTaxDisplay&&typeof window.RKTaxDisplay.formatNetUnit==='function')return window.RKTaxDisplay.formatNetUnit(n,b);
    return money(n)+(b==='m2'?' / m²':' / Stk');
  }
  function unwrapExtraDetails(root){
    (root||document).querySelectorAll('details').forEach(details=>{
      if(details.dataset.rkExtraUnwrapped==='1') return;
      if(!details.querySelector('input.tk-extra,[data-maglia-extra],[data-rk-rb-extra],[data-rk-tile-extra]')) return;
      details.dataset.rkExtraUnwrapped='1';
      const parent=details.parentNode;
      [...details.childNodes].forEach(node=>{if(!(node.nodeType===1&&node.matches('summary'))) parent.insertBefore(node,details);});
      details.remove();
    });
  }
  function enhanceExtras(root){
    (root||document).querySelectorAll('[data-maglia-extra],[data-rk-rb-extra],[data-rk-tile-extra],input.tk-extra').forEach(input=>{
      const label=input.closest('label'); if(!label) return;
      label.classList.add('rk-v8-extra-card');
      const title=clean(input.dataset.code||input.dataset.label||input.value||input.name||'Extra');
      const b=basis(input.dataset.basis||input.dataset.priceBasis||input.dataset.bassis||'Stk');
      input.dataset.basis=b;
      const price=Number(String(input.dataset.price||input.dataset.unit||input.dataset.priceChf||0).replace(',','.'))||0;
      const safeTitle=title.replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
      const desired='<strong>'+safeTitle+'</strong>'+(price>0?'<small data-rk-extra-tax-price>'+priceWithTax(price,b)+'</small>':'');
      const market=(window.RuckstuhlMarket&&typeof window.RuckstuhlMarket.current==='function'&&window.RuckstuhlMarket.current())||{};
      const signature=title+'|'+b+'|'+price+'|'+taxMode()+'|'+String(market.country_code||market.currency_code||'');
      let content=label.querySelector('.rk-v8-extra-content');
      if(!content){
        content=document.createElement('span'); content.className='rk-v8-extra-content';
        [...label.childNodes].forEach(n=>{if(n!==input) n.remove();});
        label.appendChild(content);
      }
      if(label.dataset.rkExtraSignature!==signature){
        label.dataset.rkExtraSignature=signature;
        content.innerHTML=desired;
      }
      label.querySelectorAll('.rk-maglia__check,i').forEach(el=>el.remove());
    });
  }
  function updateFinalNav(root){
    (root||document).querySelectorAll('.rk-at-modal,.rk-rb-modal,.rk-maglia__modal,.rk-tile-modal').forEach(modal=>{
      const steps=[...modal.querySelectorAll('.rk-at-step,.rk-rb-step,.rk-maglia__step,.rk-tile-step')].filter(s=>!s.hidden);
      const active=steps.find(s=>s.classList.contains('is-active'));
      if(!active||!steps.length) return;
      const last=active===steps[steps.length-1];
      const next=modal.querySelector('[data-rk-at-next],[data-rk-rb-next],[data-next],[data-rk-tile-next]');
      if(!next) return;
      const desired=last?'Schliessen':'Weiter';
      if(clean(next.textContent)!==desired) next.textContent=desired;
      next.disabled=false;
      next.removeAttribute('aria-disabled');
    });
  }
  function init(root){unwrapExtraDetails(root);enhanceExtras(root);updateFinalNav(root);}
  let scheduledRoot=null;
  function schedule(root){
    scheduledRoot=root||document;
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{const scope=scheduledRoot||document;scheduledRoot=null;queued=false;init(scope);});
  }
  function modalFrom(node){return node&&node.closest?node.closest('.rk-at-modal,.rk-rb-modal,.rk-maglia__modal,.rk-tile-modal'):null;}
  document.addEventListener('DOMContentLoaded',()=>init(document));
  window.addEventListener('rk:tax-display-change',()=>requestAnimationFrame(()=>enhanceExtras(document)));
  window.addEventListener('ruckstuhl:market-change',()=>requestAnimationFrame(()=>enhanceExtras(document)));
  document.addEventListener('change',e=>{
    if(e.target&&e.target.matches('[data-maglia-extra],[data-rk-rb-extra],[data-rk-tile-extra],input.tk-extra')){
      const scope=modalFrom(e.target)||e.target.closest('label')||document;
      enhanceExtras(scope);updateFinalNav(scope);
    }
  });
  document.addEventListener('click',e=>{
    const modal=modalFrom(e.target);
    if(!modal)return;
    if(e.target.closest('[data-rk-at-next],[data-rk-at-prev],[data-rk-at-progress-index],[data-rk-rb-next],[data-rk-rb-prev],[data-next],[data-prev],[data-rk-tile-next],[data-rk-tile-prev]')){
      requestAnimationFrame(()=>updateFinalNav(modal));
    }
  });
  new MutationObserver(records=>{
    for(const record of records){
      for(const node of record.addedNodes||[]){
        if(node.nodeType!==1) continue;
        const relevant=node.matches&&node.matches('.rk-at-modal,.rk-rb-modal,.rk-maglia__modal,.rk-tile-modal,details,[data-maglia-extra],[data-rk-rb-extra],[data-rk-tile-extra],input.tk-extra')
          || (node.querySelector&&node.querySelector('.rk-at-modal,.rk-rb-modal,.rk-maglia__modal,.rk-tile-modal,details [data-maglia-extra],details [data-rk-rb-extra],details [data-rk-tile-extra],details input.tk-extra'));
        if(relevant){schedule(modalFrom(node)||node);return;}
      }
    }
  }).observe(document.documentElement,{subtree:true,childList:true});
})()
